import React, { Component, Fragment } from 'react';
import { Elevation, Typography } from 'rmwc';
import { TabBar, Tab } from 'rmwc/Tabs';
import { Text } from '../components/Text';
import PlanScore from '../components/PlanScore';
import LetterScore from '../components/charts/LetterScore';
import NumericScore from '../components/charts/NumericScore';
import { logEvent } from '../helpers/analytics';

export class PlanScorePanel extends Component {
  //= ({ results, updatedScores, moneyLastsUntilAge, hideTitle = false }) => (
  constructor(props) {
    super(props);

    this.state = { activeTabIndex: 1 };
  }

  onTab = evt => {
    logEvent('ScorePanelTabClick', {
      show: evt.target.value == 1 ? 'with' : 'without',
    });
    this.setState({ activeTabIndex: evt.target.value });
  };

  render() {
    let { displayTabBar, results, updatedScores, moneyLastsUntilAge, hideTitle } = this.props;

    if (displayTabBar && results && !updatedScores) {
      updatedScores = {
        readiness_grade: this.props.results.scores.readiness_grade * 1.1,
        retirement_spending_power: this.props.results.scores.retirement_spending_power * 1.15,
        money_lasts_until: this.props.results.scores.money_lasts_until + 2,
      };
    }
    if (displayTabBar && !this.state.activeTabIndex) {
      updatedScores = null;
    }

    //console.log(results, updatedScores, 'UPDATED SCORES');

    return (
      <Fragment>
        {!hideTitle && (
          <Text className="mt-0 mb-0" use="headline6">
            Your Retirement Score
          </Text>
        )}
        {displayTabBar && (
          <TabBar
            className="ml-0 actionPlanIntro action-plan-tabs"
            activeTabIndex={this.state.activeTabIndex}
            onChange={this.onTab}
          >
            <Tab>Without a plan</Tab>
            <Tab>After finishing a plan</Tab>
          </TabBar>
        )}
        <PlanScore
          scores={[
            {
              title: 'Overall Retirement Readiness',
              score: (
                <LetterScore
                  title="Retirement Spending Power"
                  initialValue={results && results.scores.readiness_grade * 100}
                  updateValue={updatedScores && updatedScores.readiness_grade * 100}
                />
              ),
            },
            {
              title: 'Retirement Spending Power',
              score: (
                <NumericScore
                  title=""
                  initialValue={results && results.scores.retirement_spending_power}
                  updateValue={
                    updatedScores && updatedScores.results
                      ? updatedScores.retirement_spending_power
                      : results && results.scores.retirement_spending_power
                  }
                  format="DOLLARS_PER_YEAR"
                  benchmark_title="Your Retirement Expenses"
                  benchmark_amount={results && results.benchmarks.retirement_expenses}
                />
              ),
            },
            {
              title: 'Your Money Should Last Until',
              score: (
                <NumericScore
                  title=""
                  initialValue={results && moneyLastsUntilAge(results.scores.money_lasts_until)}
                  updateValue={
                    updatedScores
                      ? moneyLastsUntilAge(updatedScores.money_lasts_until)
                      : results && moneyLastsUntilAge(results.scores.money_lasts_until)
                  }
                  format="AGE"
                  benchmark_title="Planning Until"
                  benchmark_amount={93}
                />
              ),
            },
          ]}
        />
      </Fragment>
    );
  }
}

export default PlanScorePanel;
